import ApiCaller from 'actions/ApiCaller';
import baseAjaxConfig, { headers } from 'actions/BaseAjaxConfig';
export var generateLoginOTP;
(function (generateLoginOTP) {
    generateLoginOTP["USER_GENERATE_OTP"] = "USER_GENERATE_OTP";
    generateLoginOTP["USER_GENERATE_OTP_SUCCESS"] = "USER_GENERATE_OTP_SUCCESS";
    generateLoginOTP["USER_GENERATE_OTP_ERROR"] = "USER_GENERATE_OTP_ERROR";
})(generateLoginOTP || (generateLoginOTP = {}));
export function generateLoginOtp(_body) {
    const userHeaders = Object.assign({}, headers, {
        'Content-Type': 'application/x-www-form-urlencoded'
    });
    return (dispatch) => {
        dispatch({
            type: generateLoginOTP.USER_GENERATE_OTP
        });
        return ApiCaller.post(Object.assign({}, baseAjaxConfig, {
            pathname: '/api/5/user/otp/generate',
            headers: userHeaders,
            acceptErrors: true,
            action: generateLoginOTP.USER_GENERATE_OTP
        }), _body).then(json => dispatch({
            type: generateLoginOTP.USER_GENERATE_OTP_SUCCESS,
            data: json['RESPONSE']
        }), err => {
            return Promise.reject(dispatch({
                type: generateLoginOTP.USER_GENERATE_OTP_ERROR,
                error: err
            }));
        });
    };
}
/* This version '/api/7/user/otp/generate' generates and sends OTP to one Login Identifier.
 * This gets used in Login with OTP.
 */
export function generateLoginWithOtp(_body) {
    return (dispatch) => {
        dispatch({
            type: generateLoginOTP.USER_GENERATE_OTP
        });
        return ApiCaller.post(Object.assign({}, baseAjaxConfig, {
            pathname: '/api/7/user/otp/generate',
            acceptErrors: true,
            action: generateLoginOTP.USER_GENERATE_OTP
        }), _body).then(json => dispatch({
            type: generateLoginOTP.USER_GENERATE_OTP_SUCCESS,
            data: json['RESPONSE']
        }), err => {
            return Promise.reject(dispatch({
                type: generateLoginOTP.USER_GENERATE_OTP_ERROR,
                error: err
            }));
        });
    };
}
/* This version '/api/8/user/otp/generate' generates and sends OTP to both old and new Identifiers(both email and mobile)
 * This gets used in my accounts for updating mobile/email/passwords.
 */
export function generateLoginIdentityVerifyOtp(_body) {
    const userHeaders = Object.assign({}, headers, {
        flipkart_secure: true
    });
    return (dispatch) => {
        dispatch({
            type: generateLoginOTP.USER_GENERATE_OTP
        });
        return ApiCaller.post(Object.assign({}, baseAjaxConfig, {
            pathname: '/api/8/user/otp/generate',
            headers: userHeaders,
            acceptErrors: true,
            action: generateLoginOTP.USER_GENERATE_OTP
        }), _body).then(json => dispatch({
            type: generateLoginOTP.USER_GENERATE_OTP_SUCCESS,
            data: json['RESPONSE']
        }), err => {
            return Promise.reject(dispatch({
                type: generateLoginOTP.USER_GENERATE_OTP_ERROR,
                error: err
            }));
        });
    };
}
